module.exports = __webpack_public_path__ + "img/720x900-soru-1.58e01699.jpg";